import Vue from "vue";
import Default from "./Default.vue";
import Admin from "./Admin.vue";

Vue.component("default-layout", Default);
Vue.component("admin-layout", Admin);
